/*
 * @Author: 李朋飞
 * @Date: 2021-07-15 19:02:21
 * @LastEditTime: 2021-09-06 10:33:45
 * @Description: 计算属性，相当于 vue文件内的computed
 * 页面内使用， mapGetters 取出本文件内所有的内容
 * import { mapGetters } from 'vuex';
 * computed: {
    ...mapGetters(['items'])
    },

    也可以通过 $store.state.items来获取
 */

export const menuList = function (state) {
  return state.menuList;
};
export const conversationList = function (state) {
  return state.conversationList;
};


// WEBPACK FOOTER //
// ./src/store/getters.js